import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { LocaleCurrency } from 'types/Shared/Locale'
import { getUserPreferencesSelectedCurrency } from 'selectors/user/cookie'
import { getSelectedFacetsPrice } from 'selectors/algolia2/facets'
import { getHrefFunction } from './helper'
import { getSelectedFacetsPriceMinMax } from 'selectors/facets/priceFacet'

const mapStateToProps = createStructuredSelector({
  getHref: getHrefFunction,
  selectedCurrency: getUserPreferencesSelectedCurrency,
  selectedPrice: getSelectedFacetsPrice,
  priceMinMax: getSelectedFacetsPriceMinMax,
})

export type PriceFacetConnectorProps = {
  getHref: (filterParam: Record<string, any>) => string
  selectedCurrency: LocaleCurrency
  selectedPrice: string | null | undefined
  priceMinMax: { priceMin: number | null; priceMax: number | null }
}

export default connect(mapStateToProps)
